var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheapestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.671,
    height: 26.542,
    viewBox: "0 0 32.671 26.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(4182.914 992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M310.59,235.1a4.747,4.747,0,0,0-.952,1.245q-4.883,6.992-9.737,14c-.5.727-1.032,1.439-1.509,2.184-.253.4-.408.346-.705.044a27.717,27.717,0,0,0-2.152-2.106c-1.108-1.216-2.289-2.361-3.478-3.5.03-.247.257-.3.419-.405q4.134-2.665,8.274-5.321c2.416-1.552,4.84-3.091,7.242-4.663a14.851,14.851,0,0,0,2.182-1.481.308.308,0,0,0,.211-.21Q310.651,234.838,310.59,235.1Z",
    transform: "translate(-4460.844 -1226.888)",
    fill: "#40b5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M154.961,484.7c-.069-.144-.2-.087-.315-.1-.316-.046-.516-.232-.486-.544.028-.294.261-.42.555-.41.255.009.51.031.765.029.32,0,.63.005.736.389s-.218.475-.436.638Z",
    transform: "translate(-4337.071 -1450.162)",
    fill: "#0888cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M270.553,236.874a14.85,14.85,0,0,1-2.182,1.481c-2.4,1.572-4.827,3.111-7.242,4.663q-4.138,2.658-8.274,5.321c-.162.1-.389.158-.419.405a1.072,1.072,0,0,0-.214.557q-.653,2.844-1.31,5.686c-.034.149-.029.317-.242.329-.493-1.522-.837-3.084-1.245-4.629-.512-1.939-1.008-3.883-1.511-5.824q1.8-.646,3.593-1.29,6.623-2.361,13.246-4.718l5.616-2Z",
    transform: "translate(-4421.223 -1228.653)",
    fill: "#0087cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M235.153,236.113l-5.616,2q-6.623,2.359-13.246,4.718-1.8.641-3.593,1.29l-4.02-3.654c1.278-.226,2.456-.443,3.636-.641,1.5-.252,3.012-.482,4.516-.734,1.989-.333,3.975-.678,5.963-1.017q4.786-.814,9.572-1.626c.835-.141,1.672-.276,2.508-.412A.26.26,0,0,1,235.153,236.113Z",
    transform: "translate(-4386.007 -1227.912)",
    fill: "#40b5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M274.815,359.481c.214-.012.208-.18.242-.329q.654-2.843,1.31-5.686a1.072,1.072,0,0,1,.214-.557c1.189,1.136,2.37,2.28,3.478,3.5q-2.347,1.6-4.695,3.2c-.138.094-.284.176-.427.264l-.083-.19Z",
    transform: "translate(-4445.368 -1332.818)",
    fill: "#0079c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M225.235,456.239a.613.613,0,0,1-.285.46,16.662,16.662,0,0,1-1.665,1.077.424.424,0,0,1-.624-.116.449.449,0,0,1,.106-.673c.56-.382,1.125-.76,1.708-1.106A.476.476,0,0,1,225.235,456.239Z",
    transform: "translate(-4398.462 -1425.164)",
    fill: "#0c89cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M187.981,475.993a.519.519,0,0,1-.336.477c-.655.221-1.313.437-1.976.631a.468.468,0,0,1-.589-.358.424.424,0,0,1,.318-.552c.656-.219,1.315-.432,1.979-.624C187.728,475.466,187.915,475.663,187.981,475.993Z",
    transform: "translate(-4364.804 -1442.887)",
    fill: "#0c89cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M255.47,436.93a.452.452,0,0,1-.456-.261.378.378,0,0,1,.067-.47c.31-.312.634-.61.961-.905a.362.362,0,0,1,.469,0,.461.461,0,0,1,.23.426A2.364,2.364,0,0,1,255.47,436.93Z",
    transform: "translate(-4427.548 -1406.685)",
    fill: "#108bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M275.086,418.988l.083.19C275.04,419.159,275.074,419.069,275.086,418.988Z",
    transform: "translate(-4445.6 -1392.128)",
    fill: "#0087cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheapestIcon);
export default __webpack_public_path__ + "static/media/cheapest-icon.9e50a5a0ecfdd1aa830764b34a375727.svg";
export { ForwardRef as ReactComponent };